// Значки секций и строк (референсы Марата 25.08: пункт-карточка как в
// Xiaomi Home — значок в круге + название + подпись; у секции значок в
// круге рядом с заголовком, ниже наполнение). Штрих 1.8, как иконки дока.
// Рисует их только скин v3 (v3.css поверхности /app); в базовом zeit.css
// круги скрыты.

const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
} as const;

export function IcClock() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2.5" />
    </svg>
  );
}
export function IcChecklist() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <rect x="4" y="3.5" width="16" height="17" rx="3" />
      <path d="m8.5 12 2.4 2.4 4.6-4.8" />
    </svg>
  );
}
export function IcTasks() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="m8.5 12.2 2.3 2.3 4.7-4.9" />
    </svg>
  );
}
export function IcBox() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <path d="M3.5 8 12 3.5 20.5 8v8L12 20.5 3.5 16z" />
      <path d="M3.5 8 12 12.5 20.5 8M12 12.5v8" />
    </svg>
  );
}
export function IcMinusCircle() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M8 12h8" />
    </svg>
  );
}
export function IcCalendar() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <rect x="4" y="5.5" width="16" height="14.5" rx="3" />
      <path d="M4 10.5h16M8.5 3v4M15.5 3v4" />
    </svg>
  );
}
export function IcCalendarPlus() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <rect x="4" y="5.5" width="16" height="14.5" rx="3" />
      <path d="M4 10.5h16M8.5 3v4M15.5 3v4M12 13v4M10 15h4" />
    </svg>
  );
}
export function IcFlag() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <path d="M6 21V4M6 4h11.5L15 8l2.5 4H6" />
    </svg>
  );
}
export function IcUser() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20a7 7 0 0 1 14 0" />
    </svg>
  );
}
export function IcRuble() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <path d="M9 19V5h5a3.5 3.5 0 0 1 0 7H7M7 16h7" />
    </svg>
  );
}
export function IcGrad() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <path d="M12 4 2.5 8.8 12 13.5l9.5-4.7z" />
      <path d="M6 11v4.6c0 1.6 2.7 2.9 6 2.9s6-1.3 6-2.9V11" />
    </svg>
  );
}
export function IcUsers() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <circle cx="9" cy="8.5" r="3.2" />
      <path d="M3.5 19.5a5.5 5.5 0 0 1 11 0M15.5 5.7a3.2 3.2 0 0 1 0 5.6M17.5 14.4c1.8.8 3 2.9 3 5.1" />
    </svg>
  );
}
export function IcShield() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <path d="m12 3 7 3v5.2c0 4.4-2.9 7.9-7 9.8-4.1-1.9-7-5.4-7-9.8V6z" />
    </svg>
  );
}
export function IcPlane() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <path d="M21.5 3 11 13.5M21.5 3l-6.7 18-3.8-7.5L3.5 9.7z" />
    </svg>
  );
}
// Настоящая шестерёнка (правка 18.09, круг «Сезон»): прежняя была «звёздочкой»
// из восьми лучей и на 21px в круге читалась плохо. Зубчатый контур + отверстие
// r=3 — как в эталонной иконке настроек.
export function IcGear() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.08a2 2 0 0 1 1 1.74v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}
// Восход — дневные смены (правка 18.09): дуга солнца над горизонтом + лучи
// сверху, не путать с полумесяцем ночной смены (IcMoon).
export function IcSunrise() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <path d="M12 3v4.5" />
      <path d="m8.5 9.5-1.8-1.8M17.3 7.7l-1.8 1.8" />
      <path d="M7 17a5 5 0 0 1 10 0" />
      <path d="M3 17h18" />
    </svg>
  );
}
// Лупа — поиск-пилюля в «Меню» (правка 18.09).
export function IcSearch() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <circle cx="11" cy="11" r="7" />
      <path d="m20.5 20.5-4.3-4.3" />
    </svg>
  );
}
export function IcGlobe() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M3.5 12h17M12 3.5c2.6 2.2 2.6 14.8 0 17-2.6-2.2-2.6-14.8 0-17z" />
    </svg>
  );
}
export function IcLock() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <rect x="5" y="10.5" width="14" height="9.5" rx="2.5" />
      <path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5" />
    </svg>
  );
}
export function IcArrowOut() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <path d="M7 17 17 7M9 7h8v8" />
    </svg>
  );
}
export function IcHome() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <path d="m4 10.5 8-6.5 8 6.5V19a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19z" />
      <path d="M9.5 20.5v-6h5v6" />
    </svg>
  );
}
export function IcIdCard() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <rect x="3" y="5" width="18" height="14" rx="2.5" />
      <circle cx="8.5" cy="11" r="2" />
      <path d="M6 15.5c.5-1.3 1.4-2 2.5-2s2 .7 2.5 2M14 9.5h4M14 13h4" />
    </svg>
  );
}

export function IcExit() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <path d="M14.5 8V5.5a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h6.5a2 2 0 0 0 2-2V16M9.5 12H21M17.5 8.5 21 12l-3.5 3.5" />
    </svg>
  );
}
export function IcMoon() {
  return (
    <svg viewBox="0 0 24 24" {...stroke}>
      <path d="M20 14.2A8.3 8.3 0 1 1 9.8 4a6.8 6.8 0 0 0 10.2 10.2z" />
    </svg>
  );
}
export function IcBell() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6.5 16.5v-5a5.5 5.5 0 0 1 11 0v5l1.5 2h-14l1.5-2z" />
      <path d="M10 20.5a2 2 0 0 0 4 0" />
    </svg>
  );
}
export function IcClockSmall() {
  return (
    <svg viewBox="0 0 24 24" {...stroke} strokeWidth={2}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2.5" />
    </svg>
  );
}

// Шеврон «дальше» (правка Марата 25.08: текстовый ‹›› был еле заметен).
// В базовом zeit.css — простая серая стрелка, в v3.css она в кружке.
// Диагональная стрелка ↗ (правка 18.09, круг «Сезон», вариант А) — тот же
// путь продублирован в ZeitMenu (через этот же компонент) и в
// ZeitTraining.tsx (Chevron2 — свой независимый рисунок без кружка).
export function Chevron() {
  return (
    <i className="z-chev" aria-hidden>
      <svg viewBox="0 0 24 24" {...stroke} strokeWidth={2}>
        <path d="M7 17 17 7M8 7h9v9" />
      </svg>
    </i>
  );
}

// Эмблема KLAIT (шапка приложения и экраны входа/PIN). Своя разметка,
// не строчный значок из stroke-набора выше — заливка, не обводка.
export function KaitMark() {
  return (
    <svg className="z3-mark" viewBox="0 0 749 317" aria-label="KLAIT">
      <path
        fillRule="evenodd"
        d="M 562 67 L 568 61 L 739 61 L 746 67 L 747 74 L 744 82 L 650 231 L 644 227 L 627 206 L 641 182 L 642 172 L 639 164 L 563 75 Z M 2 10 L 4 5 L 9 2 L 410 2 L 430 7 L 443 14 L 458 27 L 605 198 L 621 214 L 635 232 L 641 238 L 645 238 L 645 240 L 642 242 L 616 283 L 599 302 L 583 313 L 566 315 L 560 313 L 551 305 L 531 279 L 394 118 L 379 112 L 198 112 L 193 118 L 196 124 L 273 216 L 289 222 L 461 222 L 474 232 L 518 285 L 518 289 L 515 292 L 251 292 L 235 288 L 219 280 L 202 265 L 105 141 L 100 137 L 4 17 Z"
      />
    </svg>
  );
}
